import { memo } from "react";
import Answer from "./Answer";
import AnswerDateRange from "./AnswerDateRange";
import AnswerDD from "./AnswerDD";
import AnswerRadio from "./AnswerRadio";
import AnswerTracker from "./AnswerTracker";
import AnswerCounter from "./AnswerCounter";

const RenderAnswer = ({ answer, question, containerClassName = "py-3", ...props }) => {
  const hideAnswer = answer?.answer?.other_details?.visibility == "hidden";
  return (
    !hideAnswer && (
      <div className={`${containerClassName}`}>
        {/* {question?.question_type} */}
        {props.showQuestion !== false && (
          <div className="d-flex align-itmes-center gap-10 mb-2">
            <h6 className="m-0 fw-sbold themeBlue pb-1">
              {question?.question}
            </h6>
          </div>
        )}
        {question?.question_type === "textarea_radio" ? (
          <AnswerRadio
            answer={answer}
            question={question}
          />
        ) : question?.question_type === "textarea_dd" ? (
          <AnswerDD
            answer={answer}
            question={question}
          />
        ) : question?.question_type === "date" ? (
          <AnswerDateRange
            answer={answer}
          />
        ) : question?.question_type === "tracker" ? (
          <AnswerTracker
            answer={answer}
            question={question}
          />
        ) : question?.question_type === "counter" ? (
          <AnswerCounter
            answer={answer}
          />
        ) : (
          <Answer
            answer={answer}
          />
        )}
      </div>
    )
  );
};

export const RenderAnswerByQId = memo(function ({ questionId, reportQuestions, reportAnswers, ...props }) {
  const question = reportQuestions?.length && reportQuestions?.find((q) => q.id === questionId);
  const answer = reportAnswers?.length && reportAnswers?.find((a) => a.question_id === questionId);
  return (
    <RenderAnswer
      answer={answer}
      question={question}
      {...props}
    />
  )
});

export default RenderAnswer;